// extracted by mini-css-extract-plugin
module.exports = {"title":"fonts__title__1_G_W","title-bold":"fonts__title-bold__23pYa"};